import type { InsuranceProductVersionWithDateFormat, PricingVersionTuple } from '../../model/model.ts'

import type { RcdaNomenclatureVersion } from './rcda-product-version.ts'

type RcdaPricingVersionFormat = `rcda-${number}.${number}-${InsuranceProductVersionWithDateFormat}`

export const rcdaPricingVersions = [
  ['rcda-1.0-2024-11-19', { label: 'Version 1' }],
  ['rcda-1.1-2025-01-08', { label: 'Version 1.1 - Fix history takeover' }],
  ['rcda-2.0-2025-02-10', { label: 'Version 2 - Update activities rate and premium' }],
  ['rcda-2.1-2025-07-01', { label: 'Version 2.1 - Update management fee and installment fee rate' }],
  ['rcda-3.0-2025-07-04', { label: 'Version 3 - RCDA v3 with extended coverage' }],
  ['rcda-3.1-2026-01-27', { label: 'Version 3.1 - 2026 pricing update' }],
  ['rcda-4.0-2026-07-30', { label: 'Version 4 - 2026 RCDA v4 pricing update' }],
  ['rcda-4.0.1-2027-01-01', { label: 'Version 4.0.1 - Terrorism tax €8.50' }],
  ['rcda-4.1-2026-09-04', { label: 'Version 4.1 - 2026 RCDA v4 pricing update for Renewal (old zonier)' }],
  ['rcda-4.1.1-2027-01-01', { label: 'Version 4.1.1 - Terrorism tax €8.50 for renewals (old zonier)' }],
] as const satisfies PricingVersionTuple<RcdaPricingVersionFormat>[]

export type RcdaPricingVersion = (typeof rcdaPricingVersions)[number][0]

export const rcdaPricingVersionForNomenclatureVersion: Record<RcdaNomenclatureVersion, RcdaPricingVersion> = {
  '1.0-2024-11-19': 'rcda-1.0-2024-11-19',
  '1.1-2025-01-08': 'rcda-1.1-2025-01-08',
  '2.0-2025-02-10': 'rcda-2.0-2025-02-10',
  '2.1-2025-07-01': 'rcda-2.1-2025-07-01',
  '3.0-2025-07-04': 'rcda-3.0-2025-07-04',
  '3.1-2026-07-16': 'rcda-3.1-2026-01-27',
  '3.2-2026-08-05': 'rcda-3.1-2026-01-27',
  '4.0-2026-07-30': 'rcda-4.0-2026-07-30',
}
